import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RotaProtegida({ children, tipo }) {
  const { utilizador, carregando } = useAuth();
  const location = useLocation();

  if (carregando) {
    return (
      <div style={{minHeight:'100vh',background:'#060E1C',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:'16px',fontFamily:'Plus Jakarta Sans,sans-serif'}}>
        <div style={{width:'40px',height:'40px',background:'#F97316',borderRadius:'10px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'22px',fontWeight:'800',color:'#fff',fontFamily:'Syne,sans-serif'}}>K</div>
        <div style={{fontSize:'13px',color:'rgba(255,255,255,0.4)'}}>A carregar...</div>
      </div>
    );
  }

  if (!utilizador) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (tipo) {
    const isAdmin        = utilizador.tipo === 'admin';
    const tipoCorreto    = utilizador.tipo === tipo;
    // cliente com modo fornecedor activado pode aceder a rotas de fornecedor
    const dualFornecedor = tipo === 'fornecedor' && (utilizador.pode_fornecer === true);

    if (!isAdmin && !tipoCorreto && !dualFornecedor) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}
